import {ACCEPT_IMAGE_PROP} from "../../../newShared/constants";

export const INPUT_CLIENT_DATA_FILE_ACCEPT = ACCEPT_IMAGE_PROP;

export const KYC_DATE_FORMAT = 'YYYY-MM-DD';